
export default function SearchFormatFilter() {
    return function (input/*, scope*/) {
        input = input.replace(/[+-=&|><!(){}\[\]^"~*?:\/\\ ]/g, function myFunction(x) {
            return "\\" + x;
        });
        return input.toLowerCase();
    };
}
